import { StradaDTO } from './strada-dto';
import { LocalitaDTO } from './localita-dto';

export class IndirizzoDTO {
	strada: StradaDTO;
	localita: LocalitaDTO;
}